import { useEffect, EffectCallback, DependencyList } from 'react';
import useSelectedCommunity from '../community/useSelectedCommunity';

export default function useCommunityEffect(effect: EffectCallback, dependencies: DependencyList) {
  const community = useSelectedCommunity();

  useEffect(effect, [community?.id, ...dependencies]);
}
